module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_07-9262fc3351f409cb16d3d97c01b4e370.png";